import { h } from 'preact';

function RightArrow (props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="#fff" {...props}>
      <path d="M29.844 13.094a1.995 1.995 0 00-1.696 1.336 1.995 1.995 0 00.508 2.101L35.125 23H10a2.001 2.001 0 100 4h25.125l-6.5 6.469a2.011 2.011 0 002.844 2.843l9.875-9.906L42.78 25l-1.437-1.406-9.875-9.907a1.998 1.998 0 00-1.625-.593z" />
    </svg>
  );
}

export default RightArrow;
